import { render, staticRenderFns } from "./PaymentRequestView.vue?vue&type=template&id=6afd9dc4&"
import script from "./PaymentRequestView.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequestView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports